import { useState } from 'react';
import {
    useGetAttachmentHistoryQuery,
    useGetDownloadHistoryQuery,
    useGetRequestHistoryQuery
} from '../../../services/historyApi';

function useMyHistory({ openDrawer }: any) {
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const {
        data: requestsHistory,
        isLoading: loadingRH,
        isFetching: fetchingRH
    } = useGetRequestHistoryQuery(undefined, {
        skip: !openDrawer || value !== 0,
        refetchOnMountOrArgChange: true
    });

    const {
        data: downloadHistory,
        isLoading: loadingDH,
        isFetching: fetchingDH
    } = useGetDownloadHistoryQuery(undefined, {
        skip: !openDrawer || value !== 1,
        refetchOnMountOrArgChange: true
    });

    const {
        data: attachmentHistory,
        isLoading: loadingAH,
        isFetching: fetchingAH
    } = useGetAttachmentHistoryQuery(undefined, {
        skip: !openDrawer || value !== 2,
        refetchOnMountOrArgChange: true
    });

    const loading = loadingRH || fetchingRH || loadingDH || fetchingDH || loadingAH || fetchingAH;

    return { value, handleChange, requestsHistory, attachmentHistory, downloadHistory, loading };
}

export default useMyHistory;
